import { useFormikContext } from "formik";
import { useEffect } from "react";
import InputFormik from "../../../../common/components/form/InputFormik";
import { maskCurrency } from "@/common/helpers/mask.helpers";

type Props = {
  instalments: {
    installmentNumber: string;
    value: number;
    dueDate: string | Date;
  }[];
  qtdInstalment: number;
  setQtdInstalment: (qtd: number) => void;
}

export default function FormEditInstalments(props: Props) {

  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    props.instalments.map((instalment, i) => {
      setFieldValue(`expectedDate${i}`, (instalment.dueDate as string).split('T')[0])
      setFieldValue(`expectedDateValue${i}`, String(instalment.value))
      setFieldValue('financial.qtdInstalment', props.qtdInstalment)
    })
  }, [setFieldValue, props.instalments, props.qtdInstalment]);

  return (
    <>
      <InputFormik className="mt-2" onChange={el => props.setQtdInstalment(Number(el.target.value))} label="Número de Parcelas" name="financial.qtdInstalment" type="number" required></InputFormik>
      {
        new Array(props.qtdInstalment).fill(null).map((_, i) => {
          return (
            <div id="instalment">
              <InputFormik type="date" className="mt-2" label={`Data da parcela ${i + 1}º`} name={`expectedDate${i}`} required></InputFormik>
              <InputFormik className="mt-2" label={`Valor da parcela ${i + 1}º`} name={`expectedDateValue${i}`}
                    mask={maskCurrency}
                    required={true}></InputFormik>
            </div>
          )
        })
      }
    </>
  )
}